import * as React from 'react'
import { cn } from '~/lib/utils'

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        ref={ref}
        className={cn(
          'w-full rounded-none border border-[var(--line-strong)] bg-surface-2 px-[14px] py-[12px]',
          'text-[14px] text-ink placeholder:text-ink-mute',
          'transition-colors duration-[120ms] ease-in-out',
          'focus-visible:outline-none focus-visible:border-accent',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        {...props}
      />
    )
  },
)
Input.displayName = 'Input'

export { Input }
